export default [
  {
    path: "/login",
    name: "login",
    component: () => import("../views/account/login.vue"),
    meta: {
      title: "Login",
      guestOnly: true,
    },
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("../views/account/register.vue"),
    meta: {
      title: "Register",
      guestOnly: true,
    },
  },
  {
    path: "/",
    name: "default",
    meta: {
      title: "Dashboard",
      authRequired: true,
    },
    component: () => import("../views/dashboard/ecommerce/index.vue"),
  },
  {
    path: "/dashboard/users",
    name: "users.index",
    meta: {
      title: "Analytics", authRequired: true,
    },
    component: () => import("../views/users/index"),
  },
  {
    path: "/dashboard/users/:id",
    name: "users.edit",
    meta: {
      title: "Analytics", authRequired: true,
    },
    component: () => import("../views/users/[id]"),
  },
  {
    path: "/dashboard/team-members",
    name: "team-members.index",
    meta: {
      title: "Team Members", authRequired: true,
    },
    component: () => import("../views/team-members/index"),
  },
  {
    path: "/dashboard/team-members/create",
    name: "team-members.create",
    meta: {
      title: "Create Team Member", authRequired: true,
    },
    component: () => import("../views/team-members/create"),
  },
  {
    path: "/dashboard/team-members/:id/edit",
    name: "team-members.edit",
    meta: {
      title: "Edit Team Member", authRequired: true,
    },
    component: () => import("../views/team-members/[id]"),
  },
  {
    path: "/dashboard/roles",
    name: "roles.index",
    meta: {
      title: "Analytics", authRequired: true,
    },
    component: () => import("../views/roles/index"),
  },
  {
    path: "/dashboard/roles/create",
    name: "roles.create",
    meta: {
      title: "Analytics", authRequired: true,
    },
    component: () => import("../views/roles/create"),
  },
  {
    path: "/dashboard/roles/:id/edit",
    name: "roles.edit",
    meta: {
      title: "Analytics", authRequired: true,
    },
    component: () => import("../views/roles/[id]"),
  },
  {
    path: "/dashboard/permissions",
    name: "permissions.index",
    meta: {
      title: "Permissions", authRequired: true,
    },
    component: () => import("../views/permissions/index"),
  },
  {
    path: "/dashboard/permissions/create",
    name: "permissions.create",
    meta: {
      title: "Create Permission", authRequired: true,
    },
    component: () => import("../views/permissions/create"),
  },
  {
    path: "/dashboard/permissions/:id/edit",
    name: "permissions.edit",
    meta: {
      title: "Edit Permission", authRequired: true,
    },
    component: () => import("../views/permissions/[id]"),
  },
  {
    path: "/dashboard/faq",
    name: "faq.index",
    meta: {
      title: "Analytics", authRequired: true,
    },
    component: () => import("../views/faq/index"),
  },
  {
    path: "/dashboard/faq/create",
    name: "faq.create",
    meta: {
      title: "Analytics", authRequired: true,
    },
    component: () => import("../views/faq/create"),
  },
  {
    path: "/dashboard/faq/:id/edit",
    name: "faq.edit",
    meta: {
      title: "Analytics", authRequired: true,
    },
    component: () => import("../views/faq/[id]"),
  },
  {
    path: "/dashboard/groups",
    name: "groups.index",
    meta: {
      title: "Analytics", authRequired: true,
    },
    component: () => import("../views/groups/index"),
  },
  {
    path: "/dashboard/groups/create",
    name: "groups.create",
    meta: {
      title: "Analytics", authRequired: true,
    },
    component: () => import("../views/groups/create"),
  },
  {
    path: "/dashboard/groups/:id/edit",
    name: "groups.edit",
    meta: {
      title: "Analytics", authRequired: true,
    },
    component: () => import("../views/groups/[id]"),
  },
  {
    path: "/dashboard/statistics",
    name: "statistics.index",
    meta: {
      title: "Analytics", authRequired: true,
    },
    component: () => import("../views/statistics/index"),
  },
  {
    path: "/dashboard/statistics/create",
    name: "statistics.create",
    meta: {
      title: "Analytics", authRequired: true,
    },
    component: () => import("../views/statistics/create"),
  },
  {
    path: "/dashboard/statistics/:id/edit",
    name: "statistics.edit",
    meta: {
      title: "Analytics", authRequired: true,
    },
    component: () => import("../views/statistics/[id]"),
  },
  {
    path: "/dashboard/timeline-events",
    name: "timeline-events.index",
    meta: {
      title: "Analytics", authRequired: true,
    },
    component: () => import("../views/timeline-events/index"),
  },
  {
    path: "/dashboard/timeline-events/create",
    name: "timeline-events.create",
    meta: {
      title: "Analytics", authRequired: true,
    },
    component: () => import("../views/timeline-events/create"),
  },
  {
    path: "/dashboard/timeline-events/:id/edit",
    name: "timeline-events.edit",
    meta: {
      title: "Analytics", authRequired: true,
    },
    component: () => import("../views/timeline-events/[id]"),
  },
  {
    path: "/dashboard/testimonials",
    name: "testimonials.index",
    meta: {
      title: "Analytics", authRequired: true,
    },
    component: () => import("../views/testimonials/index"),
  },
  {
    path: "/dashboard/testimonials/create",
    name: "testimonials.create",
    meta: {
      title: "Analytics", authRequired: true,
    },
    component: () => import("../views/testimonials/create"),
  },
  {
    path: "/dashboard/testimonials/:id/edit",
    name: "testimonials.edit",
    meta: {
      title: "Analytics", authRequired: true,
    },
    component: () => import("../views/testimonials/[id]"),
  },
  {
    path: "/dashboard/consultations",
    name: "consultations.index",
    meta: {
      title: "Consultations", authRequired: true,
    },
    component: () => import("../views/consultations/index"),
  },
  {
    path: "/dashboard/consultations/create",
    name: "consultations.create",
    meta: {
      title: "Create Consultation", authRequired: true,
    },
    component: () => import("../views/consultations/create"),
  },
  {
    path: "/dashboard/consultations/:id/edit",
    name: "consultations.edit",
    meta: {
      title: "Edit Consultation", authRequired: true,
    },
    component: () => import("../views/consultations/[id]"),
  },
  {
    path: "/dashboard/appointments",
    name: "appointments.index",
    meta: { title: "Appointments", authRequired: true },
    component: () => import("../views/appointments/index"),
  },
  {
    path: "/dashboard/appointments/calendar",
    name: "appointments.calendar",
    meta: { title: "Booking calendar", authRequired: true },
    component: () => import("../views/appointments/calendar"),
  },
  {
    path: "/dashboard/appointments/:id",
    name: "appointments.show",
    meta: { title: "Appointment", authRequired: true },
    component: () => import("../views/appointments/[id]"),
  },
  {
    path: "/dashboard/doctor-schedules",
    name: "doctor-schedules.index",
    meta: { title: "Doctor Schedules", authRequired: true },
    component: () => import("../views/doctor-schedules/index"),
  },
  {
    path: "/dashboard/doctor-schedules/create",
    name: "doctor-schedules.create",
    meta: { title: "Create Schedule", authRequired: true },
    component: () => import("../views/doctor-schedules/create"),
  },
  {
    path: "/dashboard/doctor-schedules/:id/edit",
    name: "doctor-schedules.edit",
    meta: { title: "Edit Schedule", authRequired: true },
    component: () => import("../views/doctor-schedules/[id]"),
  },
  {
    path: "/dashboard/doctor-time-offs",
    name: "doctor-time-offs.index",
    meta: { title: "Doctor Time Off", authRequired: true },
    component: () => import("../views/doctor-time-offs/index"),
  },
  {
    path: "/dashboard/doctor-time-offs/create",
    name: "doctor-time-offs.create",
    meta: { title: "Create Time Off", authRequired: true },
    component: () => import("../views/doctor-time-offs/create"),
  },
  {
    path: "/dashboard/doctor-time-offs/:id/edit",
    name: "doctor-time-offs.edit",
    meta: { title: "Edit Time Off", authRequired: true },
    component: () => import("../views/doctor-time-offs/[id]"),
  },
  {
    path: "/dashboard/languages",
    name: "languages.index",

    meta: {
      title: "Analytics", authRequired: true,
    },
    component: () => import("../views/languages/index"),
  },
  {
    path: "/dashboard/languages/create",
    name: "languages.create",
    meta: {
      title: "Analytics", authRequired: true,
    },
    component: () => import("../views/languages/create"),
  },
  {
    path: "/dashboard/languages/:id/edit",
    name: "languages.edit",
    meta: {
      title: "Analytics", authRequired: true,
    },
    component: () => import("../views/languages/[id]"),
  },
  {
    path: "/dashboard/page-seos",
    name: "page-seos.index",
    meta: {
      title: "Analytics", authRequired: true,
    },
    component: () => import("../views/page-seos/index"),
  },
  {
    path: "/dashboard/page-seos/create",
    name: "page-seos.create",
    meta: {
      title: "Analytics", authRequired: true,
    },
    component: () => import("../views/page-seos/create"),
  },
  {
    path: "/dashboard/page-seos/:id/edit",
    name: "page-seos.edit",
    meta: {
      title: "Analytics", authRequired: true,
    },
    component: () => import("../views/page-seos/[id]"),
  },
  {
    path: "/dashboard/settings",
    name: "settings.index",
    meta: {
      title: "Site Settings", authRequired: true,
    },
    component: () => import("../views/settings/index"),
  },
  {
    path: "/dashboard/settings/create",
    name: "settings.create",
    meta: {
      title: "Create Site Settings", authRequired: true,
    },
    component: () => import("../views/settings/create"),
  },
  {
    path: "/dashboard/settings/:id/edit",
    name: "settings.edit",
    meta: {
      title: "Edit Site Settings", authRequired: true,
    },
    component: () => import("../views/settings/[id]"),
  },
  {
    path: "/dashboard/locations",
    name: "locations.index",
    meta: {
      title: "Locations", authRequired: true,
    },
    component: () => import("../views/locations/index"),
  },
  {
    path: "/dashboard/locations/create",
    name: "locations.create",
    meta: {
      title: "Create Location", authRequired: true,
    },
    component: () => import("../views/locations/create"),
  },
  {
    path: "/dashboard/locations/:id/edit",
    name: "locations.edit",
    meta: {
      title: "Edit Location", authRequired: true,
    },
    component: () => import("../views/locations/[id]"),
  },
  {
    path: "/dashboard/services",
    name: "services.index",
    meta: {
      title: "Analytics", authRequired: true,
    },
    component: () => import("../views/services/index"),
  },
  {
    path: "/dashboard/services/create",
    name: "services.create",
    meta: {
      title: "Analytics", authRequired: true,
    },
    component: () => import("../views/services/create"),
  },
  {
    path: "/dashboard/services/:id/edit",
    name: "services.edit",
    meta: {
      title: "Analytics", authRequired: true,
    },
    component: () => import("../views/services/[id]"),
  },
  // Projects are disabled in the panel; backend routes remain available.
  {
    path: "/dashboard/projects",
    name: "projects.index",
    meta: {
      title: "Portfolio", authRequired: true,
    },
    component: () => import("../views/projects/index"),
  },
  {
    path: "/dashboard/projects/create",
    name: "projects.create",
    meta: {
      title: "Create Portfolio", authRequired: true,
    },
    component: () => import("../views/projects/create"),
  },
  {
    path: "/dashboard/projects/:id/edit",
    name: "projects.edit",
    meta: {
      title: "Edit Portfolio", authRequired: true,
    },
    component: () => import("../views/projects/[id]"),
  },
  {
    path: "/dashboard/posts",
    name: "posts.index",
    meta: {
      title: "Analytics", authRequired: true,
    },
    component: () => import("../views/posts/index"),
  },
  {
    path: "/dashboard/posts/create",
    name: "posts.create",
    meta: {
      title: "Analytics", authRequired: true,
    },
    component: () => import("../views/posts/create"),
  },
  {
    path: "/dashboard/posts/:id/edit",
    name: "posts.edit",
    meta: {
      title: "Analytics", authRequired: true,
    },
    component: () => import("../views/posts/[id]"),
  },
  {
    path: "/dashboard/post-categories",
    name: "post-categories.index",
    meta: {
      title: "Analytics", authRequired: true,
    },
    component: () => import("../views/post-categories/index"),
  },
  {
    path: "/dashboard/post-categories/create",
    name: "post-categories.create",
    meta: {
      title: "Analytics", authRequired: true,
    },
    component: () => import("../views/post-categories/create"),
  },
  {
    path: "/dashboard/post-categories/:id/edit",
    name: "post-categories.edit",
    meta: {
      title: "Analytics", authRequired: true,
    },
    component: () => import("../views/post-categories/[id]"),
  },
  {
    path: "/dashboard/products",
    name: "products.index",
    meta: {
      title: "Analytics", authRequired: true,
    },
    component: () => import("../views/products/index"),
  },
  {
    path: "/dashboard/products/create",
    name: "products.create",
    meta: {
      title: "Analytics", authRequired: true,
    },
    component: () => import("../views/products/create"),
  },
  {
    path: "/dashboard/products/:id/edit",
    name: "products.edit",
    meta: {
      title: "Analytics", authRequired: true,
    },
    component: () => import("../views/products/[id]"),
  },
  {
    path: "/dashboard/product-categories",
    name: "product-categories.index",
    meta: {
      title: "Analytics", authRequired: true,
    },
    component: () => import("../views/product-categories/index"),
  },
  {
    path: "/dashboard/product-categories/create",
    name: "product-categories.create",
    meta: {
      title: "Analytics", authRequired: true,
    },
    component: () => import("../views/product-categories/create"),
  },
  {
    path: "/dashboard/product-categories/:id/edit",
    name: "product-categories.edit",
    meta: {
      title: "Analytics", authRequired: true,
    },
    component: () => import("../views/product-categories/[id]"),
  },
  {
    path: "/dashboard/promotions",
    name: "promotions.index",
    meta: {
      title: "Analytics", authRequired: true,
    },
    component: () => import("../views/promotions/index"),
  },
  {
    path: "/dashboard/promotions/create",
    name: "promotions.create",
    meta: {
      title: "Analytics", authRequired: true,
    },
    component: () => import("../views/promotions/create"),
  },
  {
    path: "/dashboard/promotions/:id/edit",
    name: "promotions.edit",
    meta: {
      title: "Analytics", authRequired: true,
    },
    component: () => import("../views/promotions/[id]"),
  },
  {
    path: "/dashboard/galleries",
    name: "galleries.index",
    meta: {
      title: "Analytics", authRequired: true,
    },
    component: () => import("../views/galleries/index"),
  },
  {
    path: "/dashboard/galleries/create",
    name: "galleries.create",
    meta: {
      title: "Analytics", authRequired: true,
    },
    component: () => import("../views/galleries/create"),
  },
  {
    path: "/dashboard/galleries/:id/edit",
    name: "galleries.edit",
    meta: {
      title: "Analytics", authRequired: true,
    },
    component: () => import("../views/galleries/[id]"),
  },
  {
    path: "/dashboard/sections",
    name: "sections.index",
    meta: {
      title: "Analytics", authRequired: true,
    },
    component: () => import("../views/sections/index"),
  },
  {
    path: "/dashboard/sections/create",
    name: "sections.create",
    meta: {
      title: "Analytics", authRequired: true,
    },
    component: () => import("../views/sections/create"),
  },
  {
    path: "/dashboard/sections/:id/edit",
    name: "sections.edit",
    meta: {
      title: "Analytics", authRequired: true,
    },
    component: () => import("../views/sections/[id]"),
  },
  {
    path: "/pages/profile",
    name: "profile",
    meta: { title: "Profile", authRequired: true },
    component: () => import("../views/pages/profile/simple"),
  },
  {
    path: "/pages/profile-setting",
    name: "profile-setting",
    meta: { title: "Setting", authRequired: true },
    component: () => import("../views/pages/profile/setting"),
  }
];